import React from 'react';
import Socials from '../../UI/Socials';
import Contacts from '../../UI/Contacts';

const Footer = () => {
    return (
        <footer className='footer'>
            <div className="container mt-4">
                <div className="row align-items-center align-items-xl-start justify-content-between">
                    <div className="col-xl-auto d-flex d-xl-block flex-column align-items-center mb-3 mb--sm4 mb-xl-0">
                        <nav className="footer__nav">
                            <ul>
                                <li>
                                    <a target="blank" href="https://asklepiy-dv.ru/about/nasha-missiya-i-cennosti/">О клинике</a>
                                </li>
                                <li>
                                    <a target="blank" href="https://asklepiy-dv.ru/services/">Услуги и цены</a>
                                </li>
                                <li>
                                    <a target="blank" href="https://asklepiy-dv.ru/specialists/">Врачи</a>
                                </li>
                                <li>
                                    <a target="blank" href="https://asklepiy-dv.ru/reviews/">Отзывы</a>
                                </li>
                                <li>
                                    <a target="blank" href="https://asklepiy-dv.ru/karta-sajta/">Карта сайта</a>
                                </li>
                            </ul>
                        </nav>
                        <button className="btn btn_red btn_md mt-4 mt-sm-3">
                            <i className="bi bi-envelope-open me-3"></i>
                            <span>Письмо директору</span>
                        </button>
                        <div className="mt-4 mt-sm-3">
                            <Socials />
                        </div>
                    </div>
                    <div className="col-sm-auto text-center text-sm-start">
                        <a className="d-block" href="https://prodoctorov.ru/vladivostok/lpu/15930-asklepiy/" target="blank">
                            <img src="img/logos/prodoctorov.png" alt="ПРОДОКТОРОВ" />
                        </a>
                    </div>
                    <div className="col-sm-auto text-center text-sm-start mt-4 mt-sm-0">
                        <Contacts />
                        <div className="footer__img mt-2">
                            <img src="img/logos/payment.png" alt="Типы оплаты" />
                        </div>
                        <p className="footer__ref mt-2">
                            <strong>Optimo</strong> -
                            <a target="blank" href="https://www.optimo.su/"> создание</a> и
                            <a target="blank" href="https://www.optimo.su/seo/"> продвижение </a>
                            сайта
                        </p>
                    </div>
                </div>
            </div>
            <div className="footer__text mt-4">
                <div className="container">
                    <p className="py-3">
                        Уважаемые пациенты, для получения подробной информации о наличии и
                        стоимости указанных услуг, пожалуйста, обращайтесь к менеджеру сайта
                        с помощью специальной формы связи или по телефону во Владивостоке:
                        <a href="tel:74232790000"> +7 (423) 279-0000</a>.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;